var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-excel payout-upload-excel-file" },
    [
      !_vm.uploading
        ? _c(
            "el-upload",
            {
              ref: "upload_" + _vm.type,
              attrs: {
                action: "#",
                drag: "",
                "auto-upload": false,
                limit: _vm.limitNum,
                accept: ".xls,.xlsx",
                "on-change": _vm.handleFile.bind(this, _vm.type),
                "on-remove": _vm.handleRemove.bind(this, _vm.type),
                "on-exceed": _vm.handleFileExceed.bind(this, _vm.type),
                "file-list": _vm.fileList,
              },
            },
            [
              _c("div", [
                _c("i", { staticClass: "el-icon-upload" }),
                _vm.$store.getters.language === "zh"
                  ? _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v(_vm._s(_vm.$t("tips.drag_here_click_upload"))),
                    ])
                  : _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v("Drag here or "),
                      _c("em", { staticStyle: { color: "#3855F1" } }, [
                        _vm._v(" click to upload "),
                      ]),
                    ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.uploading
        ? _c("div", { staticClass: "parse" }, [_vm._v(" Parsing ")])
        : _vm._e(),
      _c("Progress", { attrs: { progress: _vm.uploadingProgress } }),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-card",
          attrs: {
            title: _vm.$t("system.user_authentication"),
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            width: "500px",
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.initData,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c(
            "div",
            {
              staticStyle: {
                width: "420px",
                "font-style": "normal",
                "font-weight": "400",
                "font-size": "18px",
                "line-height": "22px",
                color: "#4B5567",
              },
            },
            [
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "tips.MFA_verification_code_authenticate_user_access"
                    )
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { "margin-top": "30px" },
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "mfa_code", required: "" } },
                [
                  _c("el-input", {
                    staticClass: "search-mfa-frame",
                    attrs: {
                      placeholder: "Enter your MFA verification code",
                      autocomplete: "off",
                      maxlength: "6",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.mfa_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "mfa_code", $$v)
                      },
                      expression: "form.mfa_code",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v(_vm._s(_vm.$t("components.cancel"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.submiting, type: "primary" },
                  on: { click: _vm.onClickSubmitApproveBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-card",
          attrs: {
            title: _vm.$t("payment_links.duplicate_upload_detected"),
            "close-on-click-modal": false,
            visible: _vm.sameDialogVisible,
            width: "500px",
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.sameDialogVisible = $event
            },
            close: _vm.onClickCancelUpload,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "word-break": "keep-all",
                "font-size": "14px",
                "line-height": "22px",
                color: "#4B5567",
              },
            },
            [
              _c("div", {
                staticClass: "el-message-box__status el-icon-warning",
                staticStyle: { position: "static", margin: "40px 10px 0 0" },
              }),
              _c("p", { staticStyle: { margin: "20px 0 -15px" } }, [
                _vm._v(_vm._s(_vm.$t("payment_links.tip_6"))),
              ]),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.submiting },
                  on: { click: _vm.onClickProceedUpload },
                },
                [_vm._v(_vm._s(_vm.$t("payment_links.proceed_upload")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onClickCancelUpload },
                },
                [_vm._v(_vm._s(_vm.$t("payment_links.cancel_upload")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }